import FooterProprioLogo from '../v1.2.0/ui/footer-proprio-logo';
import { LinkButton } from '../v1.2.0/ui/LinkButton';
import React, { MouseEvent } from 'react';

interface ContactLinksProps {
  onNavigate: (path: string) => void;
}

function ContactLinks({ onNavigate }: ContactLinksProps): React.JSX.Element {
  return (
    <div className="content-stretch flex flex-col gap-[12px] items-start relative shrink-0">
      <LinkButton
        href="/contact-us"
        onClick={(e: MouseEvent) => {
          e.preventDefault();
          onNavigate('/contact-us');
        }}
        variant="ghost"
        size="md"
        fullWidth
        className="relative shrink-0 justify-start"
        style={{ fontVariationSettings: "'wdth' 100" }}
      >
        Contact Us
      </LinkButton>
      <LinkButton
        href="/terms-and-conditions"
        onClick={(e: MouseEvent) => {
          e.preventDefault();
          onNavigate('/terms-and-conditions');
        }}
        variant="ghost"
        size="md"
        fullWidth
        className="relative shrink-0 justify-start"
        style={{ fontVariationSettings: "'wdth' 100" }}
      >
        Terms & Conditions
      </LinkButton>
      <LinkButton
        href="/privacy-policy"
        onClick={(e: MouseEvent) => {
          e.preventDefault();
          onNavigate('/privacy-policy');
        }}
        variant="ghost"
        size="md"
        fullWidth
        className="relative shrink-0 justify-start"
        style={{ fontVariationSettings: "'wdth' 100" }}
      >
        Privacy Policy
      </LinkButton>
    </div>
  );
}

interface FooterContentProps {
  onNavigate: (path: string) => void;
}

function FooterContent({ onNavigate }: FooterContentProps): React.JSX.Element {
  return (
    <div className="content-stretch flex items-start justify-between relative shrink-0 w-full">
      <ContactLinks onNavigate={onNavigate} />
      {/* Responsive logo: ProprioMark below 440px, full logo above */}
      <div className="h-[42.255px] w-[153.155px]">
        <FooterProprioLogo />
      </div>
    </div>
  );
}

interface FooterProps {
  onNavigate: (path: string) => void;
}

export function Footer({ onNavigate }: FooterProps): React.JSX.Element {
  return (
    <div className="bg-button-active w-full mt-auto" data-name="Footer">
      <div className="flex flex-col items-center w-full">
        <div className="box-border content-stretch flex flex-col gap-[24px] md:gap-[36 px] lg:gap-[48px] items-center px-[36px] py-[24px] relative w-full pt-[46px] pr-[36px] pb-[24px] pl-[36px]">
          <FooterContent onNavigate={onNavigate} />
          <p className="relative shrink-0 text-center w-full" style={{ fontSize: 'var(--text-caption)', fontVariationSettings: "'wdth' 100" }}>
            All Right Reserved. Proprio {new Date().getFullYear()} ©.
          </p>
        </div>
      </div>
    </div>
  );
}
